export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinatário:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuário não encontrado"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contatos"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mais detalhes"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar usuários"])}
}